import { render } from "./DarkModeSwitch.vue?vue&type=template&id=45a5737c&ts=true"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=ts"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__